import {AbstractService} from 'services/AbstractService';

const PROJECT_LABELS_LIST_URL = '/api/projects/{0}/placements/labels';
const ACCOUNT_LABELS_LIST_URL = '/api/placements/labels';


export class LabelsService extends AbstractService {
  async getProjectLabels (accountId, projectId, labelChannels) {
    return (await this.client.get(PROJECT_LABELS_LIST_URL.format(projectId), {
      channel_id: labelChannels
    })).items;
  }

  async getAccountsLabels (accountIds) {
    return (await this.client.get(
      ACCOUNT_LABELS_LIST_URL,
      {account_id: accountIds}
    )).items;
  }
}
